<template>
  <div class="page-forgot-password">
    <div class="page-forgot-password__header">
      <div class="page-forgot-password__back" @click="changeRouter">
        <BaseIcon class="page-forgot-password__back-icon" name="arrow-left" />
        <span class="page-forgot-password__back-text">{{ $t('page.admin-user-profile.back') }}</span>
      </div>
      <Beacon class="page-forgot-password__beacon" />
    </div>

    <div class="page-forgot-password__content">
      <div>
        <SmallLogo class="explore__smiley" />
      </div>
      <div class="page-forgot-password__content__form" v-if="!success">
        <div class="reset-password-form__title">
          {{ $t('forgot-password.title') }}
        </div>
        <div class="reset-password-form__subtitle">
          {{ $t('forgot-password.subtitle') }}
        </div>

        <div class="page-forgot-password__form">
          <ForgotPasswordForm @submit="onSubmit($event)" />
        </div>
      </div>

      <div v-if="success">
        <div class="page-forgot-password--success__title">
          {{ $t('forgot-password.success') }}
        </div>

        <div class="page-forgot-password--success__subtitle" v-if="authenticated">
          <span>{{ username }}</span>
          {{ $t('forgot-password.success-text-second-part') }}
        </div>

        <div class="page-forgot-password--success__subtitle" v-else>
          {{ $t('forgot-password.success-text-first-part') }}
          <span>{{ username }}</span>
          {{ $t('forgot-password.success-text-second-part') }}
        </div>

        <div class="page-forgot-password--success__hint">
          {{ $t('forgot-password.success-hint') }}
          <span class="no-reply-email">
            {{ $t('forgot-password.noreply-email') }}
          </span>
          {{ $t('forgot-password.success-hint-second-part') }}

          <BaseButton class="page-forgot-password__contact-us" @click.native="contactUs" is-small is-secondary>
            {{ $t('navigation-bar.beacon') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon.vue';
import ForgotPasswordForm from '@/components/page-forgot-password/ForgotPasswordForm.vue';
import SmallLogo from '@/assets/images/aloha-logomark.svg';
import Beacon from '@/components/Beacon.vue';
import { paths } from '@/util/paths';
import { Beacon as BeaconPlugin } from '@/plugins/beacon';

import { mapGetters } from 'vuex';

export default {
  name: 'ForgotPasswordPage',
  components: {
    BaseButton,
    BaseIcon,
    Beacon,
    ForgotPasswordForm,
    SmallLogo,
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'currentUser']),
  },
  data() {
    return {
      emo: '',
      username: '',
      success: false,
    };
  },
  inject: ['$validator'],
  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    smileyUpdated(val) {
      this.emo = val;
    },
    onSubmit(username) {
      this.emo = 'thug';
      this.username = username;
      this.success = true;
    },
    changeRouter() {
      if (this.hasHistory) this.$router.go(-1);
      else {
        this.$router.push(paths.login);
      }
    },
    contactUs() {
      BeaconPlugin.toggle();
      BeaconPlugin.navigate('ask');
    },
  },
};
</script>

<style lang="scss">
.page-forgot-password {
  align-items: center;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  height: var(--viewport-height);
  padding: 32px;
  width: 100%;
  overflow: auto;

  &__header {
    display: flex;
    max-width: initial;
    width: 100%;
  }

  &__back {
    align-items: center;
    color: $color-normal;
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &:focus,
    &:active {
      color: $color-accent;
    }

    &-icon {
      color: $color-neutral;
      height: 1.4rem;
      margin-right: 8px;
      width: 20px;
    }

    &-text {
      font-size: $font-size-small;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  &__beacon {
    margin-left: auto;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 450px;
    margin: auto;
    text-align: center;

    &__form {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      .form-input__hint {
        color: $color-normal-pale;
      }
    }
  }

  &__form {
    width: 100%;
  }

  &__contact-us {
    margin-top: 15px;
    display: block;
  }

  &--success {
    &__title {
      color: $color-green;
      font-size: 2rem;
      font-stretch: normal;
      font-style: normal;
      font-weight: bold;
      letter-spacing: normal;
      line-height: normal;
      margin: 1rem 0;
    }
    &__subtitle {
      color: $color-normal-pale;
      font-family: $font-family-raleway;
      font-size: $font-size-bigger;
      font-stretch: normal;
      font-style: normal;
      font-weight: normal;
      letter-spacing: normal;
      line-height: 1.56;
      margin-bottom: 1rem;

      span {
        color: $color-normal;
        font-weight: bold;
      }
    }
    &__hint {
      color: $color-normal-pale;
      font-family: $font-family-raleway;
      font-size: $font-size-small;
      font-stretch: normal;
      font-style: normal;
      font-weight: normal;
      letter-spacing: normal;
      line-height: 1.83;
    }
  }
}

@media screen and (max-width: 784px) {
  .page-forgot-password {
    &__header {
      max-width: 450px;
    }

    &--success {
      &__title {
        font-size: 1.2rem;
      }

      &__subtitle {
        font-size: 1rem;
      }
    }
  }

  .aloha-logo-animation {
    width: 48px !important;
  }
}

.no-reply-email {
  font-weight: bold;
}
</style>
